module.exports = __webpack_public_path__ + "static/img/rank_288.2a913ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_288.png
// module id = YR0E
// module chunks = 1